/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './intra-op-recovery.reducer';

export const IntraOPRecovery = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const intraOPRecoveryList = useAppSelector(state => state.intraOPRecovery.entities);
  const loading = useAppSelector(state => state.intraOPRecovery.loading);
  const totalItems = useAppSelector(state => state.intraOPRecovery.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="intra-op-recovery-heading" data-cy="IntraOPRecoveryHeading">
        <Translate contentKey="tinyMedicRestApp.intraOPRecovery.home.title">Intra OP Recoveries</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/intra-op-recovery/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.home.createLabel">Create new Intra OP Recovery</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.intraOPRecovery.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {intraOPRecoveryList && intraOPRecoveryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('levelOfRecovery')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.levelOfRecovery">Level Of Recovery</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('levelOfRecovery')} />
                </th>
                <th className="hand" onClick={sort('coherence')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.coherence">Coherence</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('coherence')} />
                </th>
                <th className="hand" onClick={sort('reflexes')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.reflexes">Reflexes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reflexes')} />
                </th>
                <th className="hand" onClick={sort('headLift')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.headLift">Head Lift</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('headLift')} />
                </th>
                <th className="hand" onClick={sort('saeaSenosoryLevel')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.saeaSenosoryLevel">Saea Senosory Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('saeaSenosoryLevel')} />
                </th>
                <th className="hand" onClick={sort('saeaMotorLevel')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.saeaMotorLevel">Saea Motor Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('saeaMotorLevel')} />
                </th>
                <th className="hand" onClick={sort('patientReferredTo')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.patientReferredTo">Patient Referred To</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientReferredTo')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.surgeon">Surgeon</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.scrubNurse">Scrub Nurse</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPRecovery.vitals">Vitals</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {intraOPRecoveryList.map((intraOPRecovery, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/intra-op-recovery/${intraOPRecovery.id}`} color="link" size="sm">
                      {intraOPRecovery.id}
                    </Button>
                  </td>
                  <td>{intraOPRecovery.levelOfRecovery}</td>
                  <td>{intraOPRecovery.coherence}</td>
                  <td>{intraOPRecovery.reflexes}</td>
                  <td>{intraOPRecovery.headLift}</td>
                  <td>{intraOPRecovery.saeaSenosoryLevel}</td>
                  <td>{intraOPRecovery.saeaMotorLevel}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientReferredTo.${intraOPRecovery.patientReferredTo}`} />
                  </td>
                  <td>{intraOPRecovery.active ? 'true' : 'false'}</td>
                  <td>{intraOPRecovery.cursor}</td>
                  <td>{intraOPRecovery.lastupdated}</td>
                  <td>{intraOPRecovery.microSec}</td>
                  <td>{intraOPRecovery.timestampentry}</td>
                  <td>
                    {intraOPRecovery.surgery ? (
                      <Link to={`/patient-procedure/${intraOPRecovery.surgery.id}`}>{intraOPRecovery.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {intraOPRecovery.surgeon ? <Link to={`/doctor/${intraOPRecovery.surgeon.id}`}>{intraOPRecovery.surgeon.id}</Link> : ''}
                  </td>
                  <td>
                    {intraOPRecovery.scrubNurse ? (
                      <Link to={`/nurse/${intraOPRecovery.scrubNurse.id}`}>{intraOPRecovery.scrubNurse.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {intraOPRecovery.vitals ? <Link to={`/vitals/${intraOPRecovery.vitals.id}`}>{intraOPRecovery.vitals.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/intra-op-recovery/${intraOPRecovery.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/intra-op-recovery/${intraOPRecovery.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/intra-op-recovery/${intraOPRecovery.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.home.notFound">No Intra OP Recoveries found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={intraOPRecoveryList && intraOPRecoveryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default IntraOPRecovery;
